import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeNameOfSubcategory: (value: string) => void;
}

export const NameSubcategoryInput: React.FC<IProps> = React.memo(({ changeNameOfSubcategory }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSubcategoryName') }], [t]);

	return (
		<FormInput
			testId="NameSubcategoryInput"
			name="nameOfSubcategory"
			label="nameSubcategoryLabel"
			onChange={changeNameOfSubcategory}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
});
